.timeInput {
  width: 100%;
  max-width: 7.5em;
  letter-spacing: 0.5px;
  font-variant-numeric: tabular-nums;

  &.delayed {
    border: 1px solid $ontime-delay-text;
  }
}
